import React from "react"
import { connect } from "react-redux"
import { removeAdminAlert } from "../../_actions/adminAlertActionCreator"
import Alert from "../../common/Alert"

const mapStateToProps = state => ({
  alert: state.adminAlert
})

const mapDispatchToProps = dispatch => ({
  close: () => {
    dispatch(removeAdminAlert())
  }
})

function AdminAlert({ alert, close, sidebarHidden }) {
  if (alert.message && alert.message !== "") {
    return (
      <Alert
        sidebarHidden={sidebarHidden}
        type={alert.type}
        message={alert.message}
        close={close}
      />
    )
  } else {
    return null
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminAlert)
